import React from "react";
import { EventType } from "@gp/models";

import classNames from "classnames";
import { BetOffer } from "@models";
import MultiOffersComponent from "@components-shared/MultiOffersComponent";

export default function BettingType(props: {
	offer: BetOffer;
	colorClass: string;
	hasMargin?: boolean;
	isPopup?: boolean;
}) {
	if (props.offer.sportData.eventType !== EventType.NORMAL) {
		return <>{props.offer.formattedBettingTypeTip}</>;
	}

	return (
		<span
			className={classNames(props.colorClass, {
				bet__builder: props.offer.multiOffers?.length,
			})}
		>
			<span
				className={classNames({
					"u-type--wgt--bold": props.offer.multiOffers?.length,
				})}
			>
				{!props.isPopup
					? `${props.offer.formattedBettingType}`
					: `${props.offer.formattedBettingType} :`}
			</span>
			<span>
				{props.offer.formattedBettingTypeTip &&
					(!props.isPopup
						? ` (${props.offer.formattedBettingTypeTip})`
						: ` ${props.offer.formattedBettingTypeTip}`)}
			</span>
			{props.offer.multiOffers && (
				<MultiOffersComponent multiOffers={props.offer.multiOffers} />
			)}
		</span>
	);
}
